import { watch, ref, onUnmounted, reactive } from 'vue'
import { useFormStore } from '@/stores/form'
import lookups from '@/assets/json/clientLookups.json'

const deliveryMethodIdWatch = () => {
  const currentDeliveryMethodIdWatch = ref()
  const formStore = useFormStore()
  currentDeliveryMethodIdWatch.value = watch(
    () => formStore.form.values.deliveryMethodId,
    (newVal) => {
      if (newVal) {
        if (newVal == lookups.deliveryMethod.DoorToDoor) {
          formStore.extraMap = {
            ...formStore.extraMap,
            disableDeliveryCompany: true
          }
          formStore.form.setFieldValue('deliveryCompanyId', lookups.deliveryMethod.Tawzea)
        } else {
          formStore.extraMap.disableDeliveryCompany = false
        }
      }
    }
  )
  onUnmounted(() => {
    currentDeliveryMethodIdWatch.value && currentDeliveryMethodIdWatch.value()
  })
}

export default function () {
  return {
    deliveryMethodIdWatch
  }
}
